import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

/**
 * Pagina di ritorno quando l'utente annulla il pagamento su Stripe.
 * Il carrello viene mantenuto integro.
 */
export default function PaymentCancelPage() {
  return (
    <div
      data-testid="payment-cancel"
      className="px-5 sm:px-8 lg:px-12 py-24 max-w-2xl mx-auto text-center"
    >
      <div className="mx-auto w-16 h-16 rounded-full bg-white/[0.04] border border-white/15 flex items-center justify-center mb-6">
        <XCircle className="w-7 h-7 text-white/70" />
      </div>
      <div className="text-[11px] tracking-[0.32em] uppercase text-white/50 mb-3">
        Pagamento annullato
      </div>
      <h1 className="text-3xl sm:text-4xl font-extralight tracking-tight text-white">
        Nessun addebito effettuato.
      </h1>
      <p className="mt-4 text-white/60 font-light">
        Hai interrotto il pagamento. Il tuo carrello è ancora disponibile:
        puoi completare l'ordine quando vuoi.
      </p>
      <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
        <Link
          to="/carrello"
          data-testid="payment-cancel-cart"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-full border border-white/15 text-white/80 hover:text-white hover:border-white/30 transition-colors text-[11px] tracking-[0.28em] uppercase font-mono"
        >
          Torna al carrello
        </Link>
        <Link
          to="/checkout"
          data-testid="payment-cancel-retry"
          className="inline-flex items-center gap-2 px-5 py-3 rounded-full bg-emerald-400 text-black hover:bg-emerald-300 transition-colors text-[11px] tracking-[0.28em] uppercase font-medium"
        >
          Riprova il pagamento
        </Link>
      </div>
    </div>
  );
}
